module.exports = __webpack_public_path__ + "static/img/upgrade-student-tip.417a1da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/upgrade-student-tip.png
// module id = 7Njh
// module chunks = 22